import React, { useState } from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  TextField,
} from "@mui/material";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import MDDatePicker from "components/MDDatePicker";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";

function AddTimeView({ onSave }) {
  const { t } = useTranslation();
  const [newTime, setNewTime] = useState({
    from: new Date(),
    to: null,
    allDay: false,
  });

  const handleSave = () => {
    if (newTime.allDay || (newTime.from && newTime.to)) {
      onSave(newTime);
    } else {
      alert(t("trajectories.wizard.addTimeView.error.requiredFields"));
    }
  };
  const isTimeValid = () => {
    if (newTime.allDay) return true;
    if (!Array.isArray(newTime.from) || !Array.isArray(newTime.to))
      return false;
    return newTime.from[0] < newTime.to[0];
  };

  const canSave = isTimeValid();
  return (
    <Box p={3}>
      <Typography variant="h4" textAlign="center" sx={{ mb: 2 }}>
        {t("trajectories.wizard.addTimeView.title")}
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={newTime.allDay}
            onChange={(e) =>
              setNewTime({ ...newTime, allDay: e.target.checked })
            }
          />
        }
        label={t("trajectories.wizard.addTimeView.label.allDay")}
      />
      {!newTime.allDay && (
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <MDDatePicker
            label={t("trajectories.wizard.addTimeView.label.from")}
            value={newTime.from}
            onChange={(selectedDates) => {
              setNewTime({ ...newTime, from: selectedDates }); // Update the selected time
            }}
            options={{
              enableTime: true,
              noCalendar: true,
              dateFormat: "H:i", // Format as HH:mm
              time_24hr: true,
            }}
            renderInput={(params) => (
              <TextField
                placeholder="End Date"
                {...params}
                sx={{ mr: 1, mb: 2 }}
              />
            )}
          />
          <MDDatePicker
            label={t("trajectories.wizard.addTimeView.label.to")}
            value={newTime.to}
            onChange={(selectedDates) => {
              setNewTime({ ...newTime, to: selectedDates }); // Update the selected time
            }}
            options={{
              enableTime: true,
              noCalendar: true,
              dateFormat: "H:i", // Format as HH:mm
              time_24hr: true,
              minDate: newTime.from,
            }}
            renderInput={(params) => (
              <TextField
                placeholder="End Date"
                {...params}
                sx={{ mr: 1, mb: 2 }}
              />
            )}
          />
        </Box>
      )}
      <Box mt={3} sx={{ display: "flex", justifyContent: "space-between" }}>
        <MDButton
          variant="outlined"
          color="error"
          size="medium"
          sx={{ mt: 3 }}
          onClick={() => onSave(null)}
        >
          {t("common.buttons.cancel")}
        </MDButton>
        <MDButton
          variant="contained"
          color="info"
          size="medium"
          sx={{ mt: 3 }}
          onClick={handleSave}
          disabled={!canSave}
        >
          {t("trajectories.wizard.addTimeView.button.save")}
        </MDButton>
      </Box>
    </Box>
  );
}

export default AddTimeView;
